import { profileRoute } from '../Profile/route.const'

export const personalInfoRoute = () => `${profileRoute()}/personal-info`
